"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.initialRandomAwarenessChannelsOrder = exports.default = void 0;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
var _shuffle = _interopRequireDefault(require("lodash/shuffle"));
var _userAwarenessChannelConstants = _interopRequireDefault(require("./userAwarenessChannelConstants"));
var ActionTypes = _interopRequireWildcard(require("./userAwarenessActions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sortOtherLast = function sortOtherLast(first) {
  if (first === _userAwarenessChannelConstants.default.OTHER) return 1;
  return -1;
};
var initialRandomAwarenessChannelsOrder = exports.initialRandomAwarenessChannelsOrder = (0, _shuffle.default)(Object.keys(_userAwarenessChannelConstants.default)).sort(sortOtherLast);
var initialAwarenessChannels = Object.keys(_userAwarenessChannelConstants.default).reduce(function (acc, channel) {
  acc[channel] = false;
  return acc;
}, {});
var initialState = exports.initialState = {
  awarenessChannels: initialAwarenessChannels,
  randomAwarenessChannelsOrder: initialRandomAwarenessChannelsOrder,
  channelOtherText: ''
};
var userAwarenessReducer = function userAwarenessReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.TOGGLE_CHANNEL_CHECKLED:
      return _objectSpread(_objectSpread({}, state), {}, {
        awarenessChannels: _objectSpread(_objectSpread({}, state.awarenessChannels), {}, _defineProperty({}, action.payload.channel, action.payload.isChecked))
      });
    case ActionTypes.RESET_CHECKED_CHANNELS:
      return _objectSpread(_objectSpread({}, state), {}, {
        awarenessChannels: initialState.awarenessChannels
      });
    case ActionTypes.SET_CHANNEL_OTHER_TEXT:
      return _objectSpread(_objectSpread({}, state), {}, {
        channelOtherText: action.payload.channelOtherText
      });
    default:
      return state;
  }
};
var _default = exports.default = userAwarenessReducer;